var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 35,
    viewBox: "0 0 47 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2.40654e-05 34.9516V28.8016C3.39998 28.4016 5.79998 27.1016 7.19998 24.9016C8.59998 22.7016 9.29998 19.2016 9.29998 14.4016L13.8 15.0016H0.149976V0.00155985H16.2V11.7016C16.2 18.1016 14.9 23.3516 12.3 27.4516C9.79998 31.5516 5.69998 34.0516 -2.40654e-05 34.9516ZM30.7324 34.9516V28.8016C34.1324 28.4016 36.5324 27.1016 37.9324 24.9016C39.3324 22.7016 40.0324 19.2016 40.0324 14.4016L44.5324 15.0016H30.8824V0.00155985H46.9324V11.7016C46.9324 18.1016 45.6324 23.3516 43.0324 27.4516C40.5324 31.5516 36.4324 34.0516 30.7324 34.9516Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.ed3341942d258baee19333412f7208ab.svg";
export { ForwardRef as ReactComponent };